import { createActions } from '../utils/actions';

const { actions: studioVideo } = createActions('studio.video')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('getFolders')
  .addAsync('createFolder')
  .addAsync('deleteFolder')
  .addAsync('renameFolder')
  .addAsync('getItems')
  .add('setValue')
  .add('toggleVideoState')
  .addAsync('deleteItems')
  .addAsync('downloadItems')
  .addAsync('moveItems')
  .addAsync('uploadFiles');

export default studioVideo;
